import EntityPresenter, { bindPresenterMethods } from './entityPresenter'

export default class UserProfilePresenter extends EntityPresenter {
  static urn = 'user-integration'

  static async upsert(body) {
    return await this.post(`with-profile`, body)
  }

  static navOptions(key = 'user-integration') {
    const routes = {
      "user-integration": {
        icon: 'person',
        pageRoutes: ['user-integration'],
      },
    }
    return routes[key]
  }
}

bindPresenterMethods(UserProfilePresenter)
